import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { actionCreators } from "../redux/prospectsAndCustomersSagas";
import { typeOptions, customerTypeOptions, referralModeOptions } from "../constants";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { useDateFormat } from "../../../../hooks/useDateFormat";

const Filters = () => {
  const dispatch = useDispatch();
  const { calendarEndDate } = useSelector((state) => state.prospectsCustomers.currentUser);
  const filtersDirty = useSelector((state) => state.prospectsCustomers.filtersDirty);
  const isFiltersLoading = useSelector((state) => state.prospectsCustomers.isFiltersLoading);
  const loadingFilterKey = useSelector((state) => state.prospectsCustomers.loadingFilterKey);
  const dateFormat = useDateFormat();

  const selectedFilters = useSelector((state) => state.prospectsCustomers.selectedFilters);

  const {
    membership_types = [],
    sales_packages = [],
    categories = [],
    referral_categories = [],
    referral_types = []
  } = useSelector((state) => state.prospectsCustomers.filterOptions);

  const updateFilter = (key, value) => {
    dispatch(actionCreators.updateFilter({ key, value }));
  };

  const handleTypeChange = (value) => {
    if (selectedFilters.type.id === value.id) return;
    dispatch(actionCreators.updateTypeOption(value));
  };

  const handleCustomerTypeChange = (value) => {
    updateFilter("customerTypes", value);
  };

  return (
    <div id="override-edit-selection-bar" className="edit-selections-bar">
      <div className="filters-wrapper">
        <div className="filter-item">
          <p>Type</p>
          <Dropdown
            options={typeOptions}
            selectedFilters={selectedFilters.type}
            onSelectChange={handleTypeChange}
          />
        </div>

        {selectedFilters.type.id === "membership_type" && (
          <div className="filter-item">
            <p>Membership Type</p>
            {isFiltersLoading ? (
              <LoadingAnimation uiLoader />
            ) : (
              <Dropdown
                options={membership_types}
                selectedFilters={selectedFilters.membership_types}
                onSelectChange={(value) => updateFilter("membership_types", value)}
                includeSelectAll
                numberDisplayed={0}
                enableOnly
              />
            )}
          </div>
        )}

        {selectedFilters.type.id === "category" && (
          <>
            <div className="filter-item">
              <p>Category</p>
              {isFiltersLoading || loadingFilterKey === "categories" ? (
                <LoadingAnimation uiLoader />
              ) : (
                <Dropdown
                  options={categories}
                  selectedFilters={selectedFilters.categories ?? []}
                  onSelectChange={(value) => dispatch(actionCreators.updateCategory(value))}
                  haveOnSelectChange
                  includeSelectAll
                  numberDisplayed={0}
                  enableOnly
                />
              )}
            </div>
            <div className="filter-item">
              <p>Sales Package</p>
              {isFiltersLoading || loadingFilterKey === "sales_packages" ? (
                <LoadingAnimation uiLoader />
              ) : (
                <Dropdown
                  options={sales_packages}
                  selectedFilters={selectedFilters.sales_packages ?? []}
                  onSelectChange={(value) => dispatch(actionCreators.updateSalesPackage(value))}
                  includeSelectAll
                  numberDisplayed={0}
                  enableOnly
                />
              )}
            </div>
          </>
        )}

        {selectedFilters.type.id === "referral" && (
          <>
            <div className="filter-item">
              <p>Referral</p>
              <Dropdown
                options={referralModeOptions}
                selectedFilters={selectedFilters.referralMode}
                onSelectChange={(value) => updateFilter("referralMode", value)}
                includeFilter={false}
              />
            </div>
            <div className="filter-item">
              <p>
                {selectedFilters.referralMode.id === "referral_category"
                  ? "Referral Category"
                  : "Referral Type"}
              </p>

              {isFiltersLoading ? (
                <LoadingAnimation uiLoader />
              ) : selectedFilters.referralMode.id === "referral_category" ? (
                <Dropdown
                  options={referral_categories}
                  selectedFilters={selectedFilters.referral_categories}
                  onSelectChange={(value) => updateFilter("referral_categories", value)}
                  includeSelectAll
                  numberDisplayed={0}
                  enableOnly
                  key="referral_categories"
                />
              ) : (
                <Dropdown
                  options={referral_types}
                  selectedFilters={selectedFilters.referral_types}
                  onSelectChange={(value) => updateFilter("referral_types", value)}
                  includeSelectAll
                  numberDisplayed={0}
                  enableOnly
                  key="referral_types"
                />
              )}
            </div>
          </>
        )}

        <div className="filter-item">
          <p>Customer Type</p>
          <Dropdown
            options={customerTypeOptions}
            selectedFilters={selectedFilters.customerTypes}
            onSelectChange={handleCustomerTypeChange}
          />
        </div>

        <div className="filter-item ">
          <ReactDatePicker
            displayFormat={dateFormat}
            calendarEndDate={calendarEndDate}
            disabled
            startDate={calendarEndDate}
          />
        </div>
      </div>

      {filtersDirty && (
        <div className="action-buttons">
          <button className="submit" onClick={() => dispatch(actionCreators.updateData())}>
            Update
          </button>
          <button className="submit reset" onClick={() => dispatch(actionCreators.resetFilters())}>
            Reset
          </button>
        </div>
      )}
    </div>
  );
};

export default Filters;
